import { SmsAgentSection } from 'app/components/ai-agent-configuration/SmsAgentSection'
import { useSmsAgentDeployment } from 'app/components/ai-agent-configuration/useSmsAgentDeployment'

export const handle = {
  title: `SMS Agent`,
  breadcrumb: `SMS Agent`,
}

/** The SMS tab of a location's AI agent page. The tab has been offered since the SMS Agent product
 *  existed but had no route behind it, so it went nowhere. */
export default function LocationSmsAgent() {
  // Same container as the Voice tab beside it: the outlet gives only 8px, so a bare section sits
  // right under the tab bar, and unbounded width leaves the metadata strip stranded across the page.
  // pt-6 puts the heading 33px below the tabs, matching the Voice tab's first section exactly.
  return (
    <div className="max-w-[750px] pt-6 pb-16">
      <SmsAgentSection {...useSmsAgentDeployment()} />
    </div>
  )
}
